import request from '@/utils/request'

/**
 * 获取PC关于我们
 */
export function findAbout(params) {
    return request({
        url: '/pc/configInfo/pcAbout',
        method: 'get',
        params,
    })
}

export function findMobileAbout(params) {
    return request({
        url: '/pc/configInfo/mobileAbout',
        method: 'get',
        params,
    })
}

/**
 * 获取签约作品
 */
export function findSignProductList(params) {
    return request({
        url: '/pc/comicInfo/page',
        method: 'get',
        params,
    })
}

/**
 * 获取广播剧
 */
export function findDramaList(params) {
    return request({
        url: '/pc/dramaInfo/page',
        method: 'get',
        params,
    })
}

/**
 * 获取动态漫画
 */
export function findMotionComicList(params) {
    return request({
        url: '/pc/motionComicInfo/page',
        method: 'get',
        params,
    })
}

/**
 * 获取基本信息
 */
export function findBaseInfo(params) {
    return request({
        url: '/pc/configInfo/listBasic',
        method: 'get',
        params,
    })
}

/**
 * 获取描述
 */
export function findDesc(params) {
    return request({
        url: '/pc/configInfo/listBusinessScope',
        method: 'get',
        params,
    })
}

/**
 * 获取周边
 */
export function findSurrounding(params) {
    return request({
        url: '/pc/linkInfo/listProducts',
        method: 'get',
        params,
    })
}

/**
 * 获取轮播图
 */
export function findBanner(params) {
    return request({
        url: '/pc/linkInfo/slideshow',
        method: 'get',
        params,
    })
}

/**
 * 获取友情链接
 */
export function findLinkList(params) {
    return request({
        url: '/pc/linkInfo/list',
        method: 'get',
        params,
    })
}
